import React from "react";
import Button from "../../ui/Button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TenderCard = ({ title, description, onMoreDetails }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-white shadow-lg rounded-sm p-6 md:p-8 lg:p-10 relative max-w-5xl mx-auto">
      {/* Title */}
      <h2 className="text-2xl md:text-3xl font-bold text-green-800 mb-4">
        {title}
      </h2>
      {/* Description */}
      <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-6">
        {description}
      </p>
      {/* Buttons */}
      <div className="flex items-center justify-between py-2">
        <Link
          to="/path/to/documentation.pdf"
          target="_blank"
          download
          className="flex items-center xxs:text-xs xs:text-base xxs:w-min xs:w-auto font-bold text-green-800 hover:text-green-600 transition-all duration-300 transform hover:translate-x-1 hover:translate-y-1"
        >
          {t("TenderContent.tenderDownload")}
          <svg
            className="w-6 h-6 ml-2 xxs:ml-0 xs:ml-2 xxs:w-9 xxs:h-9 xs:w-6 xs:h-6 text-green-800 hover:text-green-600 transition-all duration-300 transform hover:translate-x-1 hover:translate-y-1"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V12.9726L9.56944 11.0119C9.29988 10.6974 8.8264 10.661 8.51191 10.9306C8.19741 11.2001 8.16099 11.6736 8.43056 11.9881L11.4306 15.4881C11.573 15.6543 11.7811 15.75 12 15.75C12.2189 15.75 12.427 15.6543 12.5694 15.4881L15.5694 11.9881C15.839 11.6736 15.8026 11.2001 15.4881 10.9306C15.1736 10.661 14.7001 10.6974 14.4306 11.0119L12.75 12.9726L12.75 2C12.75 1.58579 12.4142 1.25 12 1.25Z" />
            <path d="M14.25 9V9.37828C14.9836 9.11973 15.8312 9.2491 16.4642 9.79167C17.4077 10.6004 17.517 12.0208 16.7083 12.9643L13.7083 16.4643C13.2808 16.963 12.6568 17.25 12 17.25C11.3431 17.25 10.7191 16.963 10.2916 16.4643L7.29163 12.9643C6.48293 12.0208 6.5922 10.6004 7.53568 9.79167C8.16868 9.2491 9.01637 9.11973 9.74996 9.37828V9H8C5.17157 9 3.75736 9 2.87868 9.87868C2 10.7574 2 12.1716 2 15V16C2 18.8284 2 20.2426 2.87868 21.1213C3.75736 22 5.17157 22 7.99999 22H16C18.8284 22 20.2426 22 21.1213 21.1213C22 20.2426 22 18.8284 22 16V15C22 12.1716 22 10.7574 21.1213 9.87868C20.2426 9 18.8284 9 16 9H14.25Z" />
          </svg>
        </Link>

        <Button
          onClick={onMoreDetails}
          className="px-3 py-1 text-xs xxs:text-xs xxs:p-2 xs:px-3 xs:py-1 sm:px-4 sm:py-2 sm:text-sm md:px-6 md:py-3 md:text-base"
          bgColor="bg-green-800"
          textColor="text-white"
          boxShadowColor="#15803d"
        >
          {t("TenderContent.viewMore")}
        </Button>
      </div>
    </div>
  );
};

export default TenderCard;
